import React from "react";
import { Typography, Box, Theme, useTheme } from "@mui/material";
import Section from "components/common/Section";
import FONTS from "const/fonts";
import { ReactComponent as MailIcon } from "assets/icons/email.svg";
import { ReactComponent as PhoneIcon } from "assets/icons/phone.svg";
import { makeStyles } from "@mui/styles";

interface Props {
  title?: string;
  text?: string;
  contactTitle?: string;
  contactEmail?: string;
  contactPhone?: string;
  pathID: string;
  initAppl: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& .selectedJobInner": {
      maxWidth: 1390,
      margin: "0 auto",
      "& li": {
        fontFamily: FONTS.GranulaLight,
      },
    },
    "& .selectedImage": {
      backgroundPosition: "right top",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      width: "100%",
      height: 290,
      [theme.breakpoints.up("sm")]: {
        backgroundPosition: "center top",
      },
    },
    "& .backButton": {
      alignItems: "center",
      color: theme.palette.text.primary,
      display: "flex",
      "& svg": {
        height: 24,
        width: 24,
        marginRight: theme.spacing(2),
      },
    },
    "& a": {
      textDecoration: "none",
    },
    "& .downloadButton": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "8px / 50%",
      color: theme.palette.text.secondary,
      textDecoration: "none",
      width: "fit-content",
      fontFamily: FONTS.GranulaMedium,
    },
    "& .header": {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    "& .contact": {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(4),
      [theme.breakpoints.up("md")]: {
        marginTop: 0,
      },
      "& h2": {
        fontSize: "36px",
      },
    },
    "& .contactLink": {
      color: theme.palette.text.primary,
      display: "flex",
      alignItems: "center",
      fontSize: 18,
      fontFamily: FONTS.GranulaMedium,
      marginBottom: theme.spacing(2),
      textDecoration: "none",
      [theme.breakpoints.up("md")]: {
        fontSize: "24px",
      },
      "& svg": {
        width: "24px",
        marginRight: theme.spacing(2),
      },
    },
    "& .application": {
      fontFamily: FONTS.GranulaCompactMedium,
    },
    "& .container": {
      padding: theme.spacing(0, 2, 0, 0),
    },
  },
}));

const JobPortalComponent: React.FC<Props> = (props) => {
  const {
    text,
    contactTitle,
    contactEmail,
    contactPhone,
    initAppl,
    title,
    children,
  } = props;
  const theme = useTheme();
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className="gallery">
        <Section>
          <div className="header mb4">
            <div className="pr4">
              {title && (
                <Typography variant="h2" component="h1" className="mb4">
                  {title}
                </Typography>
              )}
              {text && <Typography>{text}</Typography>}
            </div>
            <div className="contact">
              {contactTitle && (
                <Typography
                  variant="h2"
                  dangerouslySetInnerHTML={{ __html: contactTitle }}
                  className="mb4"
                />
              )}
              {contactEmail && (
                <a href={`mailto:${contactEmail}`} className="contactLink mb2">
                  <MailIcon />
                  {contactEmail}
                </a>
              )}
              {contactPhone && (
                <a href={`tel:${contactPhone}`} className="contactLink mb2">
                  <PhoneIcon />
                  {contactPhone}
                </a>
              )}
            </div>
          </div>
          {children}
        </Section>
        <Section fullWidth backgroundColor={theme.palette.primary.main}>
          <Box
            px={{
              xs: 2,
              sm: 3,
              md: 4,
              lg: 7,
              xl: 0,
            }}
            maxWidth={1390}
            margin="0 auto"
          >
            <Typography
              variant="h2"
              align="left"
              gutterBottom
              color="textSecondary"
              className="application"
            >
              {initAppl}
            </Typography>
          </Box>
        </Section>
      </div>
    </div>
  );
};

export default JobPortalComponent;
